import React from 'react';
import '../../styles/transport.css'; // Import Hero specific CSS
import '../../styles/Fonts.css'; // Import Hero specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const TransportServices = () => {
  return (
    <>
      {/* Transport Services Section */}
      <section id="transport-services" className="about-preview-section">
        <div className="container">
          <div className="about-content-wrapper">
            <div className="about-text-content">
              <div className="section-badge">WHAT WE PROVIDE</div>
              <h2 className="section-title">Our Transport Services</h2>
              <p className="section-description">
                Our comprehensive transportation services ensure the seamless movement of your goods 
                with cutting-edge technology and optimized routing. We guarantee timely deliveries 
                while keeping your costs down.
              </p>
              <p className="section-description">
                Our flexible solutions adapt to your business needs, handling shipments of any size 
                and scale. Backed by industry expertise, we navigate customs, safety protocols, and 
                regulations, ensuring a smooth and compliant process every step of the way.
              </p>
              
              <div className="hero-actions mt-4">
                <a href="/contactUs" className="btn-primary-hero">Get Started</a>
              </div>
            </div>
            <div className="about-image-content">
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-shipping-fast"></i>
                  </div>
                  <span className="stat-number">Express</span>
                  <div className="stat-label">Fast delivery solutions</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-shield-alt"></i>
                  </div>
                  <span className="stat-number">Secure</span>
                  <div className="stat-label">Protected cargo transport</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-route"></i>
                  </div>
                  <span className="stat-number">Optimized</span>
                  <div className="stat-label">Smart routing technology</div>
                </div>
                <div className="stat-item">
                  <div className="stat-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <span className="stat-number">24/7</span>
                  <div className="stat-label">Round-the-clock support</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TransportServices;
